import apiCall from '../../apiCall/apiCall';
import buildUrlSearchParams from '../../apiCall/buildUrlSearchParams/buildUrlSearchParams';
// This class handles any API calls related to notes.
class Notes {
  static all(params) {
    const data = buildUrlSearchParams(params);
    return apiCall('GET', 'api/notes/items', data);
  }

  static show(id) {
    return apiCall('GET', `api/notes/items/${id}`);
  }

  static create(data) {
    return apiCall('POST', 'api/notes/items', { item: data });
  }

  static update(id, data) {
    return apiCall('PATCH', `api/notes/items/${id}`, { item: data });
  }

  static destroy(id) {
    return apiCall('DELETE', `api/notes/items/${id}`);
  }

  static getTypes(params) {
    const data = buildUrlSearchParams(params);
    return apiCall('GET', 'api/notes/types', data);
  }
}

export default Notes;
